import { createSelector } from '@reduxjs/toolkit';
import { selfSelector } from './self';

const clientsLoadingSelector = createSelector(selfSelector, (clients) => clients.isLoading);

export default clientsLoadingSelector;
